import React from 'react';
import PropTypes from 'prop-types';
import BreadCrumb from 'components/BreadCrumb';

const BreadCrumbCatalog = (props) => {

    const {filterService, filterByBrand, filters, categories} = props;

    const getCrumbs = () => {
        if(!filterService) return [];
        if (filterService.search !== '' && filterService.collections !== '') {
            const { pathname, search } = window.location;
            return [
                {
                    title: 'Resultados de Búsqueda',
                    url: pathname + search
                }
            ]
        }
    
        if(filterByBrand){
            const { pathname, search } = window.location;
            return [
                {
                    title: filters ? filters.brands.map(brand => brand.Name).join(', ') : '',
                    url: pathname + search
                }
            ]
        }
    
        let urlCategoryEmpty = '';
        if (categories.length === 0) return [];
        return categories.map((category) => {
            if(typeof category !== 'string'){
                return {
                    title: category.name,
                    url: category.url
                }
            } else {
    
                urlCategoryEmpty = urlCategoryEmpty + '/' + category;
                let categoryUrl = category.replace(/-/g,' ');
                categoryUrl = categoryUrl.charAt(0).toUpperCase() + categoryUrl.slice(1);
    
                return {
                    title: categoryUrl,
                    url: urlCategoryEmpty
                }
            }
        });
    }
    
    const crumbs = getCrumbs();

    return (
        <BreadCrumb crumbs={crumbs} />
    )
}

BreadCrumbCatalog.propTypes = {
    filterService: PropTypes.object,
    filterByBrand: PropTypes.bool,
    filters: PropTypes.object,
    categories: PropTypes.array
};

export default BreadCrumbCatalog;